<template>
  <a-form :form="form" @submit="handleSubmit">
    <a-form-item label="登录账号">
      <a-input :disabled="true" v-decorator="['username', {}]" />
    </a-form-item>
    <a-form-item label="密码">
      <a-input
        type="password"
        v-decorator="[
          'password',
          { rules: [{ required: true, message: '请输入密码' }] },
        ]"
        placeholder="请输入密码"
      />
    </a-form-item>
    <a-form-item label="确认密码">
      <a-input
        type="password"
        v-decorator="[
          'password_confirm',
          { rules: [{ required: true, message: '请再次输入密码' }] },
        ]"
        placeholder="请再次输入密码"
      />
    </a-form-item>
  </a-form>
</template>
<script>
import bus from "../../common/bus";
export default {
  props: {
    currdata: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: this.$form.createForm(this, { name: "search" }),
    };
  },
  created() {
    bus.$on("editPassword", this.handleSubmit);
  },
  mounted() {
    this.form.setFieldsValue({ username: this.currdata.username });
  },
  methods: {
    handleSubmit(e) {
      if (e) e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.password != values.password_confirm) {
            this.$message.warning("两次密码输入不一致!");
            this.$emit("callbackErr");
            return;
          }
          if (values.password == this.currdata.password) {
            this.$message.warning("密码未修改!");
            this.$emit("callbackErr");
            return;
          }
          if(!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])[\da-zA-Z\W]{8,}$/.test(values.password)) {
            this.$message.warning("请输入包含字符、数字、大小写字母且长度超过8位的密码!");
            this.$emit("callbackErr");
            return;
          }
          this.axios
            .post(
              "web/users/updPassWord/" +
                this.currdata.id ,{username:
                values.username,password:values.password}
            )
            .then(() => {
              this.$emit("callback");
              this.$message.success("修改成功!");
            });
        }else {
          this.$emit("callbackErr");
        }
      });
    },
  },
  destroyed() {
    bus.$off("editPassword");
  },
};
</script>